```vue
<template>
  <div class="dashboard">
    <!-- Sidebar -->
    <Sidebar />

    <!-- Main Content -->
    <main class="main-content">
      <!-- Header -->
      <header class="header">
        <div class="greeting">
          <WaitingDriversNumber :waiting-captains="waitingCaptains" />
        </div>
        <div class="header-icons">
          <i class="icon notifications"></i>
          <i class="icon menu"></i>
        </div>
      </header>

      <!-- Loading State -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-spinner"></div>
      </div>
      <div
        class="filters"
        style="margin-bottom: 10px; display: flex; gap: 10px"
      >
        <select v-model="filters.status" @change="changePage(1)">
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>

        <input
          placeholder="Driver ID"
          v-model.trim="filters.driverId"
          @keyup.enter="changePage(1)"
        />
        <button class="btn" @click="changePage(1)">Apply</button>
      </div>

      <!-- Requests Table -->
      <section class="requests-table">
        <table>
          <thead>
            <tr>
              <th>Nº</th>
              <th>Captain</th>
              <th>Phone Number</th>
              <th>National ID</th>
              <th>Amount</th>
              <th>Wallet</th>
              <th>View Details</th>
              <th>Type</th>

              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(request, index) in requests"
              :key="request._id"
              :class="['clickable-row', { disabled: !request?.driverId?._id }]"
              @click="
                request?.driverId?._id && navigateToConfirmRequest(request)
              "
            >
              <td>{{ (filters.page - 1) * filters.limit + index + 1 }}</td>
              <td class="captain-cell">
                <img
                  v-if="request?.driverId?.profileImage"
                  :src="request.driverId.profileImage"
                  alt="Avatar"
                  class="avatar"
                />
                <span>{{ request.driverId?.username || "N/A" }}</span>
              </td>
              <td>{{ request.driverId?.phoneNumber || "N/A" }}</td>
              <td>{{ request.driverId?.nationalId || "N/A" }}</td>
              <td>{{ formatEGP(request.amount) }}</td>
              <td>{{ request.driverId?.wallet ?? "N/A" }}</td>
              <td>View Details</td>
              <td>{{ request.type || "—" }}</td>

              <td>
                <span
                  class="status-badge"
                  :data-status="request.status || '—'"
                  @click.stop
                >
                  {{ (request.status || "—").toUpperCase() }}
                </span>
              </td>
            </tr>
            <tr v-if="requests.length === 0">
              <td colspan="9" class="no-data">No requests found</td>
            </tr>
          </tbody>
        </table>
        <!-- Table Footer (Pagination) -->
        <div class="table-footer">
          <div>
            <p>Total Requests: {{ total }}</p>
          </div>
          <div class="pagination">
            <span> {{ startIndex }}-{{ endIndex }} of {{ total }} items </span>
            <button
              :disabled="filters.page === 1"
              @click="changePage(filters.page - 1)"
            >
              prev
            </button>
            <button disabled>{{ filters.page }} / {{ pages }}</button>
            <button
              :disabled="filters.page >= pages"
              @click="changePage(filters.page + 1)"
            >
              next
            </button>
          </div>
        </div>

        <!-- Reject Modal -->
        <div
          v-if="showRejectModal"
          class="modal-overlay"
          @click.self="closeRejectModal"
        >
          <div class="modal-card">
            <h3>Reject Request</h3>
            <form @submit.prevent="submitReject">
              <div class="form-row">
                <label>Reason</label>
                <textarea
                  v-model.trim="rejectReason"
                  rows="4"
                  required
                  placeholder="Reason for rejection"
                ></textarea>
              </div>
              <div class="modal-actions">
                <button type="button" @click="closeRejectModal">Cancel</button>
                <button type="submit" :disabled="rejecting">
                  {{ rejecting ? "Rejecting..." : "Reject" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "@/axios";

import Sidebar from "../components/sidebarComponent.vue";

import WaitingDriversNumber from "@/components/waitingDriversNumber.vue";

export default {
  name: "GetReqComponent",
  components: {
    WaitingDriversNumber,
    Sidebar,
  },
  data() {
    return {
      requests: [],
      loading: true,
      adminName: localStorage.getItem("username") || "Admin",
      newRequestsCount: 0,
      total: 0,
      pages: 1,
      filters: {
        page: 1,
        limit: 10,
        driverId: "",
        status: "", // "pending" | "approved" | "rejected" | ""
      },

      waitingCaptains: 0,
      showRejectModal: false,
      rejecting: false,
      rejectReason: "",
      activeRequestId: null,
      confirmingId: null,
    };
  },
  computed: {
    startIndex() {
      if (!this.total) return 0;
      const page = Number(this.filters.page) || 1;
      const limit = Number(this.filters.limit) || 10;
      return this.requests.length ? (page - 1) * limit + 1 : 0;
    },
    endIndex() {
      if (!this.total) return 0;
      const page = Number(this.filters.page) || 1;
      const limit = Number(this.filters.limit) || 10;
      return Math.min(page * limit, this.total);
    },
  },

  async created() {
    this.hydrateFiltersFromQuery(); // ← جديد
    await this.fetchRequests();
    this.newRequestsCount = this.requests.length;
  },

  methods: {
    hydrateFiltersFromQuery() {
      const q = this.$route.query || {};
      if (q.page) this.filters.page = Number(q.page) || 1;
      if ("status" in q) this.filters.status = q.status || "";
      if (q.driverId) this.filters.driverId = q.driverId;
    },
    async fetchRequests() {
      this.loading = true;
      try {
        const { data } = await axios.get("/getReq", {
          timeout: 10000,
          params: {
            page: this.filters.page,
            limit: this.filters.limit,
            driverId: this.filters.driverId || undefined,
            status: this.filters.status || undefined,
          },
        });

        // ---- التقاط الليست من أشكال متعددة ----
        let list = [];
        let total = null,
          pages = null,
          page = null;

        // level 0
        if (Array.isArray(data?.requests)) list = data.requests;
        else if (Array.isArray(data?.request)) list = data.request;
        else if (Array.isArray(data?.data)) list = data.data;
        else if (Array.isArray(data?.docs)) list = data.docs;
        // level 1 nested
        else if (Array.isArray(data?.requests?.docs)) {
          list = data.requests.docs;
          total = data.requests.totalDocs ?? data.requests.total ?? data.total;
          pages = data.requests.totalPages ?? data.requests.pages ?? data.pages;
          page = data.requests.page ?? data.page ?? null;
        } else if (Array.isArray(data?.data?.requests)) {
          list = data.data.requests;
          total = data.data.total ?? data.total ?? null;
          pages = data.data.pages ?? data.pages ?? null;
          page = data.data.page ?? data.page ?? null;
        } else if (Array.isArray(data?.data?.docs)) {
          list = data.data.docs;
          total = data.data.totalDocs ?? data.total ?? null;
          pages = data.data.totalPages ?? data.pages ?? null;
          page = data.data.page ?? data.page ?? null;
        }

        // fallback أخير (لو رجع object فيه key واحد array)
        if (!Array.isArray(list)) {
          const firstArr = Object.values(data || {}).find(Array.isArray);
          list = Array.isArray(firstArr) ? firstArr : [];
        }

        // ---- totals / pages مرنة ----
        this.total =
          Number(
            total ??
              data?.total ??
              data?.count ??
              data?.totalDocs ??
              list.length
          ) || 0;
        const limit = Number(this.filters.limit) || 10;
        this.pages =
          Number(
            pages ??
              data?.pages ??
              data?.totalPages ??
              Math.ceil(this.total / limit)
          ) || 1;
        this.filters.page =
          Number(
            page ?? data?.page ?? data?.currentPage ?? this.filters.page
          ) || 1;

        // ---- الماب ----
        this.requests = list.map((r) => ({
          _id: r._id,
          amount: r.amount,
          status: r.status || "",
          createdAt: r.createdAt,
          updatedAt: r.updatedAt,
          type: r.type || "",
          account: r.account || "",
          holderName: r.holderName || "",
          walletBefore: r.walletBefore ?? null,
          walletAfter: r.walletAfter ?? null,
          adminName: r.adminName || "",
          transfareId: r.transfareId ?? r.transferId ?? "",
          transfareMethod: r.transfareMethod ?? r.transferMethod ?? "",
          driverId: r.driverId
            ? {
                _id: r.driverId._id || "",
                username: r.driverId.username || "N/A",
                phoneNumber: r.driverId.phoneNumber || "N/A",
                wallet: r.driverId.wallet ?? "N/A",
                nationalId: r.driverId.nationalId || "",
                profileImage:
                  r.driverId.profile_image || r.driverId.profileImage || "",
              }
            : null,
        }));

        // ✅ لو لقيتي الـ dropdown لسه واقف على approved ومش شايفة pending
        // تقدري تغيّريه من فوق من الفلتر، أو اعملي reset سريع كالتالي:
        // this.filters.status = ""; await this.fetchRequests();
      } catch (error) {
        console.error("GET /getReq error:", error);
        const status = error?.response?.status;
        const msg =
          error?.response?.data?.message || error?.message || "Unknown error";
        alert(`GET /getReq failed (${status ?? "-"} ): ${msg}`);
      } finally {
        this.loading = false;
      }
    },

    async confirmRequest(requestId) {
      if (this.confirmingId) return;
      this.confirmingId = requestId;
      try {
        await axios.post("/approveReq", { requestId }, { timeout: 10000 });

        // لو العنصر ده آخر عنصر في الصفحة الحالية، ارجعي صفحة
        if (this.requests.length === 1 && this.filters.page > 1) {
          this.filters.page -= 1;
        }

        await this.fetchRequests();
        alert("Request approved successfully!");
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error.message ||
          "Failed to approve request.";
        alert(msg);
      } finally {
        this.confirmingId = null;
      }
    },

    navigateToConfirmRequest(request) {
      if (!request?.driverId?._id) {
        alert("Cannot navigate: Driver ID is missing");
        return;
      }

      const driver = request.driverId || {};

      this.$router.push({
        name: "confirmRequest",
        params: { id: driver._id },
        query: {
          requestId: request._id || "",
          wallet: driver.wallet ?? "",
          amount: request.amount ?? 0,

          // بيانات الطلب
          status: request.status || "",
          type: request.type || "",
          account: request.account || "",
          holderName: request.holderName || "",
          createdAt: request.createdAt || "",
          updatedAt: request.updatedAt || "",
          walletBefore: request.walletBefore ?? "",
          walletAfter: request.walletAfter ?? "",

          // معلومات السائق للعرض
          driverName: driver.username || "",
          phone: driver.phoneNumber || "",

          // ابعتي الشكلين احتياطيًا
          profileImage: driver.profile_image || driver.profileImage || "",
          profile_image: driver.profile_image || driver.profileImage || "",
          adminName: request.adminName || "",
          transfareId: request.transfareId || request.transferId || "",
          transfareMethod:
            request.transfareMethod || request.transferMethod || "",
          fromPage: this.filters.page,
          fromStatus: this.filters.status,
        },
      });
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleString();
    },
    formatEGP(v) {
      const n = Number(v || 0);
      try {
        return `${n.toLocaleString("en-EG")} EGP`;
      } catch {
        return `${n} EGP`;
      }
    },

    openRejectModal(id) {
      this.activeRequestId = id;
      this.rejectReason = "";
      this.showRejectModal = true;
    },
    closeRejectModal() {
      this.showRejectModal = false;
      this.rejecting = false;
      this.rejectReason = "";
      this.activeRequestId = null;
    },
    async submitReject() {
      if (!this.activeRequestId) return alert("Request ID missing");
      if (!this.rejectReason) return alert("Please enter a rejection reason");
      this.rejecting = true;
      try {
        await axios.post(
          "/rejectReq",
          { requestId: this.activeRequestId, rejectReason: this.rejectReason },
          { timeout: 10000 }
        );

        if (this.requests.length === 1 && this.filters.page > 1) {
          this.filters.page -= 1;
        }

        await this.fetchRequests();
        alert("Request rejected successfully!");
        this.closeRejectModal();
      } catch (e) {
        const msg =
          e?.response?.data?.message || e.message || "Failed to reject";
        alert(msg);
      } finally {
        this.rejecting = false;
      }
    },
    changePage(p) {
      if (p < 1 || p > this.pages) return;

      // حدّثي الستيت فورًا علشان نعرض الداتا حالًا
      this.filters.page = p;

      // هات الداتا فورًا (حتى لو الـURL مش هيتغيّر)
      this.fetchRequests();

      // وبعدين حدّثي الـURL علشان الفلاتر تفضل محفوظة بعد الرجوع/الريفريش
      this.$router.replace({
        path: "/get-req", // تأكدي إنه نفس path عندك
        query: {
          page: this.filters.page,
          status: this.filters.status || undefined,
          driverId: this.filters.driverId || undefined,
        },
      });
    },
  },
  watch: {
    "$route.query": {
      handler() {
        this.hydrateFiltersFromQuery();
        this.fetchRequests();
      },
      immediate: false,
    },
  },
};
</script>

<style scoped>
.clickable-row.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  filter: grayscale(0.2);
}

/* Define CSS variables for consistent sizing */
:root {
  --sidebar-width: 250px;
  --sidebar-width-collapsed: 80px;
}

/* Dashboard Layout */
.dashboard {
  display: flex;
  height: 100vh;
  font-family: "Arial", sans-serif;
  justify-content: center;
}

/* Sidebar Styles */
.sidebar {
  width: var(--sidebar-width);
  background-color: #2f1c6a;
  color: white;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  z-index: 100;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 20px;
  box-sizing: border-box;
}

/* Main Content */
.main-content {
  margin-left: var(--sidebar-width);
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 20px 0 0 20px;
  box-sizing: border-box;
  overflow-x: auto;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.greeting h1 {
  font-size: 1.5rem;
  margin: 0;
  color: #2c3e50;
}

.greeting p {
  color: #7f8c8d;
  margin: 5px 0 0;
}

.header-icons i {
  font-size: 1.5rem;
  margin-left: 15px;
  cursor: pointer;
}

/* Requests Table */
.requests-table {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 2px solid #8e44ad;
}

.requests-table table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.requests-table th,
.requests-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ecf0f1;
}

.requests-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #34495e;
}

.requests-table td {
  color: #2c3e50;
}

.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable-row:hover {
  background-color: #f0f0f0;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #888;
}

/* Table Footer */
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-footer p {
  color: #2c3e50;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pagination span {
  color: #2c3e50;
}

.pagination button {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #6b48ff;
  color: white;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #ddd;
  cursor: not-allowed;
}

/* Loading Overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #6b48ff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .sidebar {
    width: var(--sidebar-width-collapsed);
  }

  .main-content {
    margin-left: var(--sidebar-width-collapsed);
  }

  .requests-table table {
    font-size: 0.9rem;
  }

  .pagination button {
    padding: 3px 8px;
  }
}

@media (min-width: 769px) {
  .main-content {
    margin-left: var(--sidebar-width);
  }
}
.btn {
  padding: 6px 10px;
  border: 1px solid #8e44ad;
  background: #6b48ff;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}
.btn:disabled {
  background: #bbb;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}
.form-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}
.form-row input,
.form-row select {
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 8px;
}
.modal-actions button {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  cursor: pointer;
}
.btn.danger {
  background: #e74c3c;
  border-color: #c0392b;
}
.btn.danger:disabled {
  background: #bbb;
}
.modal-card textarea {
  resize: vertical;
}
.status-badge {
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  text-transform: uppercase;
  border: 1px solid #ddd;
}
.status-badge[data-status="approved"] {
  background: #eaf7ee;
  border-color: #b6e2c1;
}
.status-badge[data-status="rejected"] {
  background: #fdecea;
  border-color: #f5b5ae;
}
.status-badge[data-status="pending"] {
  background: #fff7e6;
  border-color: #ffd591;
}
.clickable-row.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.status-badge {
  display: inline-block;
  min-width: 78px;
  text-align: center;
  font-weight: 600;
}
.captain-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #eee;
}
</style>
